export default ({ datepickerReact }) => ({
  cellButton: {
    '& span': {
      borderRadius: datepickerReact.dayBorderRadius,
      boxSizing: 'border-box',
      display: 'block',
      margin: '0 auto',
      textAlign: 'center',
      ...datepickerReact.cellButtonSpan,
    },
    '&:focus': {
      outlineColor: datepickerReact.focusColor,
    },
    '&:hover span': {
      background: datepickerReact.dayHoverBackground,
      borderRadius: datepickerReact.dayBorderRadius,
    },
    background: 'transparent',
    border: 0,
    boxSizing: 'border-box',
    color: datepickerReact.text,
    cursor: 'pointer',
    fontFamily: datepickerReact.fontFamily,
    height: 40,
    margin: 0,
    overflow: 'visible',
    padding: 0,
    position: 'relative',
    width: 40,
  },
  disabled: {
    '& span': {
      background: datepickerReact.background,
      color: datepickerReact.disabledDate,
    },
    cursor: 'default',
  },
  hidden: {
    '& span': {
      color: 'transparent',
    },
    '&:hover span': {
      background: 'transparent',
    },
  },
  inRange: {
    '& span, &:hover span': {
      background: datepickerReact.inRangeBackground,
      borderRadius: 0,
      width: '100%',
      ...datepickerReact.period,
    },
  },
  isToday: {
    fontWeight: 'bold',
    position: 'relative',
    zIndex: 1,
    ...datepickerReact.isToday,
  },
  selected: {
    '& span, &:hover span': {
      background: datepickerReact.selected,
      borderRadius: datepickerReact.dayBorderRadius,
      color: datepickerReact.selectedText,
    },
  },
  selectEnd: {
    '& span, &:hover span': {
      borderRadius: [0, datepickerReact.dayBorderRadius, datepickerReact.dayBorderRadius, 0],
      marginRight: 6,
      paddingLeft: 6,
    },
    '&::before': {
      zIndex: -1,
    },
    position: 'relative',
  },
  selectStart: {
    '& span, &:hover span': {
      borderRadius: [datepickerReact.dayBorderRadius, 0, 0, datepickerReact.dayBorderRadius],
      marginLeft: 6,
      paddingRight: 6,
      width: 34,
    },
    '&::before': {
      zIndex: -1,
    },
    position: 'relative',
  },
});
